import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { TemplateModel } from '../business-entities/template-model';
import { LanguageValue } from '../business-entities/language-value.model';

@Injectable({
    providedIn: 'root'
})

export class TemplateDataService {
    constructor(private dataProvider: DataService) {
    }

    getList(requestModel: any) {
        return this.dataProvider.Post<GenericResponse<any[]>>(Urls.TemplateList, requestModel).toPromise();
    }
    getTemplate(requestModel: any) {
        return this.dataProvider.Get<GenericResponse<TemplateModel>>(Urls.GetTemplate, requestModel).toPromise();
    }
    addTemplate(template: TemplateModel){
        return this.dataProvider.Post<GenericResponse<any>>(Urls.AddTemplate,template).toPromise();
    }
    updateTemplate(template: TemplateModel){
        return this.dataProvider.Post<GenericResponse<any>>(Urls.UpdateTemplate,template).toPromise();
    }
    templateDetailWithCulture(templateId:number, culture:string):Promise<GenericResponse<TemplateModel>>{
        return this.dataProvider.Get<GenericResponse<TemplateModel>>(Urls.GetDetailsWithCulture,templateId,culture).toPromise();
    }
    
    getLanguage():Promise<GenericResponse<Array<LanguageValue>>> {
        return this.dataProvider.Get<GenericResponse<Array<LanguageValue>>>(Urls.GetLanguages).toPromise();
    }

}